<pf-loading-overlay [filter]="{only: ['UpsellSubmit']}"></pf-loading-overlay>

<section>
  <div class="headline">
    <h3 class="mb-0">{{ 'upsell_page.builder.offer_details' | transloco }}</h3>
  </div>
  <div class="content" [formGroup]="form" *ngIf="form" #formRef pfScrollInvalidInput [scrollContainer]="'.main-content-wrapper'">
    <div class="content-row" *ngIf="form.get('name'); let control">
      <fieldset class="config-control">
        <label>{{ 'upsell_page.builder.offer_name' | transloco }}</label>
        <input type="text"
               class="form-control _local-has-tooltip"
               [placeholder]="'upsell_page.builder.offer_name_placeholder' | transloco"
               formControlName="name"/>
        <span class="Tooltip _local-input-tooltip" matTooltipClass="Tooltip-Box" matTooltipPosition="above"
            [matTooltip]="'upsell_page.builder.offer_name_tooltip' | transloco">
        </span>
        <ng-container *ngIf="control.errors && control.dirty">
          <small class="text-danger mb-1" *ngIf="control.errors.required">
            {{ 'upsell_page.builder.val_required' | transloco }}
          </small>
          <small class="text-danger mb-1" *ngIf="control.errors.maxlength">
            {{ 'upsell_page.builder.val_max_chars' | transloco: { max: control.errors.maxlength.requiredLength } }}
          </small>
          <small class="text-danger mb-1" *ngIf="control?.errors['space_only']">
            {{ 'upsell_page.builder.val_not_spaces_only' | transloco }}
          </small>
        </ng-container>
      </fieldset>
    </div>

    <div class="content-row" *ngIf="form.get('trigger'); let control">
      <fieldset class="config-control">
        <label>{{ 'upsell_page.builder.trigger_type' | transloco }}</label>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          formControlName="trigger"
          class="h-46"
        >
          <ng-option [value]="triggerType.Products">{{ 'upsell_page.builder.trigger_products_label' | transloco }}</ng-option>
          <ng-option [value]="triggerType.Collections">{{ 'upsell_page.builder.trigger_collections_label' | transloco }}</ng-option>
          <ng-option [value]="triggerType.All">{{ 'upsell_page.builder.trigger_all_label' | transloco }}</ng-option>
        </ng-select>
        <small>{{triggerTypeDescription}}</small>
      </fieldset>
    </div>

    <div class="content-row">
      <ng-container [ngSwitch]="form.get('trigger').value">
        <div *ngSwitchCase="triggerType.Collections" class="form-group">
          <ng-container *ngIf="form.get('trigger_collections') as control">
            <div class="d-flex flex-column align-items-start">
              <button class="pf-button filled blue mb-2" [disabled]="!isRootVariant"
                      (click)="onShowTriggerCollectionSelectorClick()">
                {{ 'upsell_page.builder.btn_select_collections' | transloco }}
              </button>
              <small *ngIf="control.dirty && control.errors" class="text-danger mb-2">{{ 'upsell_page.builder.err_select_collection' | transloco }}</small>
            </div>
            <pf-products-output
              [productsListService]="productsListService"
              [setSelection]="triggerCollectionSelection"
              [emptyText]="'upsell_page.builder.empty_collections' | transloco"
              [noValidate]="true"
              [customClass]="control.dirty && control.errors ? 'ng-invalid has-error h-182' : 'h-182'"
              [clearable]="true"
              (change)="updateTriggerCollectionSelection($event)"
            ></pf-products-output>
          </ng-container>
        </div>
        <div *ngSwitchCase="triggerType.Products" class="form-group">
          <ng-container *ngIf="form.get('trigger_products') as control">
            <div class="d-flex flex-column align-items-start">
              <button class="pf-button filled blue mb-2" [disabled]="!isRootVariant"
                      (click)="onShowTriggerProductSelectorClick()">
                {{ 'upsell_page.builder.btn_select_products' | transloco }}
              </button>
              <small *ngIf="control.dirty && control.errors" class="text-danger mb-2">{{ 'upsell_page.builder.err_select_trigger_product' | transloco }}</small>
            </div>
            <pf-products-output
              [productsListService]="productsListService"
              [setSelection]="triggerProductSelection"
              [emptyText]="'upsell_page.builder.empty_trigger_products' | transloco"
              [noValidate]="true"
              [customClass]="control.dirty && control.errors ? 'ng-invalid has-error h-182' : 'h-182'"
              [clearable]="true"
              (change)="updateTriggerProductSelection($event)"
            ></pf-products-output>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="content-row">
      <div class="form-group">
        <label class="mb-0">{{ 'upsell_page.builder.section_upsell_offer' | transloco }}</label>
        <p class="mb-2">
          <small>{{ 'upsell_page.builder.upsell_offer_hint' | transloco }}</small>
        </p>
        <ng-container *ngIf="form.get('target_products') as control">
          <div class="d-flex flex-column align-items-start">
            <button class="pf-button filled blue mb-2"
                    (click)="onShowTargetProductSelectorClick()">
              {{ 'upsell_page.builder.btn_select_target_product' | transloco }}
            </button>
            <small *ngIf="control.dirty && control.errors" class="text-danger mb-2">{{ 'upsell_page.builder.err_select_target_product' | transloco }}</small>
          </div>
          <pf-products-output
            [productsListService]="productsListService"
            [setSelection]="targetProductSelection"
            [emptyText]="'upsell_page.builder.empty_target_product' | transloco"
            [noValidate]="true"
            [customClass]="control.dirty && control.errors ? 'ng-invalid has-error h-182' : 'h-182'"
            [hidePagination]="true"
            [showOutOfStock]="true"
            [clearable]="true"
            [displayQuantity]="true"
            (change)="updateTargetProductSelection($event)"
          ></pf-products-output>
        </ng-container>
      </div>
    </div>

    <div class="content-row mt-3" *ngIf="form.get('no_repeat'); let control">
      <fieldset class="form-group">
        <label class="d-flex align-items-center">
          <mat-checkbox formControlName="no_repeat" (change)="showRepeatErrorIfNeeded()" class="mr-2"></mat-checkbox>
          {{ 'upsell_page.builder.skip_if_same' | transloco }}
        </label>
        <small *ngIf="skipError" class="text-danger mb-2">{{ 'upsell_page.builder.err_trigger_equals_target' | transloco }}</small>
      </fieldset>
    </div>

    <div class="content-row" *ngIf="form.get('discounted'); let control">
      <fieldset class="form-group">
        <label class="d-flex align-items-center">
          {{ 'upsell_page.builder.give_discount' | transloco }}
          <pf-switch-box formControlName="discounted"
            class="ml-2"
            [labelInside]="true"
            (change)="updateDiscountValidators(true)"
            [labelOff]="'campaign_plugins.common.off' | transloco"
          ></pf-switch-box>
        </label>
      </fieldset>
    </div>

    <ng-container *ngIf="form.get('discounted').value">
      <div class="content-row" *ngIf="form.get('discount_type'); let control">
        <fieldset class="config-control">
          <label>{{ 'upsell_page.builder.discount_type' | transloco }}</label>
          <ng-select
            bindValue="value"
            bindLabel="label"
            [clearable]="false"
            [searchable]="false"
            formControlName="discount_type"
            class="h-46"
            [items]="discountTypeOptions"
            (change)="updateDiscountValidators(true)"
          ></ng-select>
        </fieldset>
      </div>

      <div class="content-row" *ngIf="form.get('discount_value'); let control">
        <fieldset class="config-control">
          <label>{{ 'upsell_page.builder.discount_value' | transloco }}</label>
          <div class="input-group">
            <input type="number" min="0"
                  class="form-control"
                  formControlName="discount_value"
                  (click)="onNumberInputClick($event)"
                  (focusout)="checkIfProductIsFree()">
            <div class="input-group-append">
              <span class="input-group-text" *ngIf="form.get('discount_type').value === discountType.Percentage">%</span>
              <span class="input-group-text" *ngIf="form.get('discount_type').value === discountType.Fixed">{{userCurrencySymbol}}</span>
            </div>
          </div>
          <small class="text-muted" *ngIf="form.get('discount_type').value === discountType.Fixed">
            {{ 'upsell_page.builder.hint_discount_each_item' | transloco }}
          </small>
          <ng-container *ngIf="control.errors && control.dirty">
            <small class="text-danger mb-1" *ngIf="control.errors.required">
              {{ 'upsell_page.builder.val_discount_required' | transloco }}
            </small>
            <small class="text-danger mb-1" *ngIf="control.errors.min">
              {{ 'upsell_page.builder.val_gt_zero' | transloco }}
            </small>
            <small class="text-danger mb-1" *ngIf="control.errors.max">
              {{ 'upsell_page.builder.val_lt_max' | transloco: { max: control.errors.max?.max } }}
            </small>
          </ng-container>
        </fieldset>
      </div>
    </ng-container>

  </div>
</section>
